import src from "IMAGE";
export default { src, width: 972, height: 312, blurWidth: 0, blurHeight: 0};
